import ChooseMap from './ChooseMap'

export default ChooseMap
